 // website to download the hebrew transliterated and english : https://www.scripture4all.org/OnlineInterlinear/Hebrew_Index.htm
// website for the audio of the hebrew https://www.torahclass.com/audio-bible-in-hebrew
// https://www.ccel.org/ccel/anonymous/hebrewot/Genesis.html
//website for islam Quran https://quranwbw.com/1
export const courseRelStructuralData = [
  {
    learningTitle:"Islam",
    companyName:"Islam",
    companyHeadOfficeLocation:"Cameroon | Buea | Ndongo",
    initialData:{
      name:"About Islam",
      logo:'https://symbolsage.com/wp-content/uploads/2021/05/star-crescent-islam-symbol.jpg?c935a4&c935a4',
      menu:[
        {
          name:'Introduction',
          detail:"The aim of this Section is to provide a broad foundation on which the reader may base his further studies on the teaching of Islam",
          detail1:"",
          detail2:"",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Introduction",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Origin of Islam',
          detail:"```Islam``` is an Arabic word which means peace,purity,acceptance and submission to God. Islam is monotheistic, that is belief in one God and owes its origin form God.(Q.3:19, 3:85, 5:3).",
          detail1:"A Muslim is one who freely and willingly accept the supreme power of God and strives to organize his life in total accord with the teaching of Islam.He also works for building social institutions which reflect the guidance of God.",
          detail2:'"Mohammedanism" is a misnomer for Islam and offends its very spirit since the Prophet Mohamad(P.B.U.H)  was a messenger of God, and not a divine being worshipped by Muslims.',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Origin of Islam",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'The concept of God in Islam',
          detail:"Knowledge of God and belief in Him constitutes the very foundation of Islam. As we look around our environment, we see that every family has a head, every school has a principal, every town has a mayor, and every nation has a head of state.",
          detail1:" Moreover we know beyond doubt that every product is the work of a certain producer and every beautiful art is the creation of a great artist. One often wonders at the beauty of nature with its scientific charms and marvels. ",
          detail2:'The almost endless horizons in the sky and their reaching expansions - the ceaseless succession of day and night in the most orderly manner, the course of the sun, the moon and the stars, etc. One often wonders because one would like to know the maker and maintenance of all these things with which we live and which we immensely enjoy.',
          detail3:"Can we find an explanation of the universe? Is there any convincing interpretation of the secret of existence?",
          detail4:"In the world then there must be a great force in action to keep everything in order. In beautiful nature, there must be a great originator who creates the most charming objects and produces everything for a special purpose in life. This force is the strongest of all forces and is the cause of all forms of creation.",
          detail5:" True believers and deeply enlightened people recognize their originator and call Him Allah or God. He is not a man because no man can create or make another man. He is not an animal or a plant.",
          detail6:' According to Islam, God is unique as presented in the Holy Qur\'an "He is ALLAH(GOD), the only One. Allah helps and does not need help. He does not have a child and He was not born of anyone. There is none comparable to Him." (Holy Qur\'an 112:1-3,  Q2:255, Q59:22-24)',
          ancorName:"The concept of God in Islam",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Islamic Monotheism - Tawhid(The oneness of Allah)[part1]',
          detail:"Tawhid is the most important Islamic belief. It is the first thing that each and every matured human being must learn. It implies that everything in existence originated from one and only Creator, who is also the sustainer and the sole source of guidance. This belief should govern all aspects of human life. Allah is the sole source of Power and Authority, therefore entitled to worship and obedience from mankind. There is no chance for any partnership with the Creator.",
          detail1:"The term TAWHID is derived from the there root ```w-h-d``` which serves as the vehicle for the basic concept of  'oneness', or 'unity', along with the closely related ideas of 'singularity' and 'uniqueness'.These root letters are clearly apparent in the numerical adjective ```wahid```[one]",
          detail2:'Linguistically Towhid means: "To Make something one, or to assert the oneness of something." However what we are concerned with here is the shari\'ah or technical meaning of Towhid which is:"   To single out Almighty God alone for worship."',
          detail3:'It is asserted in the first pillar of Islam "La illaha illa llah"[ There is none worthy of worship except Allah(SWT)]. Tawhid has three aspects(diviesions).',
          detail4:"1.) Tawhid ar-Ruboobiyyah (the Oneness of God in His Lordship)",
          detail5:"2.) Tawhid al-Uloohiyyah (to single-out Almighty God alone for worship)",
          detail6:"3.) Tawhid al-Asmaa was-Sifaat (the uniqueness of God's Names and Attributes)",
          ancorName:"Islamic Monotheism - Tawhid(The oneness of Allah)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:' Tawhid ar-Ruboobiyyah (the Oneness of God in His Lordship)',
          detail:"Tawhid ar-Ruboobiyyah implies: A firm and definite belief that Almighty God alone is the  Creator, the Master, and Owner, and Command is for none but Him.",
          detail1:'God says in the Quran "Allah created all things and He is the agent on which all things depend." (Q13:16, Q6:1, Q6:102, Q35:1-3 Q39:46)',
          detail2:' A confession with your heart that the Creator (of everything) is Allah; it is that you have to say: " I testify that the Creator of all the universe including the unknown forms of life, is Allah. He is the Organizer and Planner of all its affairs. It is He who gives life and death, and He (ie Allah Alone) is the Sustainer, the Giver of security." ',
          detail3:' This is (your confession for the) "Oneness of the Lordship of Allah".',
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:" Tawhid ar-Ruboobiyyah (the Oneness of God in His Lordship)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Tawhid al-Uloohiyyah (to single-out Almighty God alone for worship)',
          detail:"Tawhid al-Uloohiyah is to single out God alone for worship and not to worship anything along with Him, whether it be an angel, a Messenger, a prophet, a pious person, a tree, a stone, the sun, the moon, or other than these.",
          detail1:' "God says in the Quran" "I did not create the Jinn and Mankind except that they should worship me"(Q51:56) ',
          detail2:'A confession with your heart that "I testify that none has the right to be worshipped but Allah Alone" ',
          detail3:'The word "worship" (ie Ibadah) means all actions or speech, public or hidden which Allah loves and accepts. E.g. prayers, implications, sacrifice for Allah, alms, zakat, fasting, recitation of the Quran, etc,',
          detail4:'Worship, therefore, carries a great number of meanings in Islamic terminology: it conveys that all kinds of worship are meant for Allah alone and none else, Whether it be an angel, messenger, Prophet Isa(Jesus (PBUH) - son of Maryam(Mary). Uzair (Ezra), Mohammad(PBUH), saint, idol, the sun, the moon, and all other kinds of false deities.',
          detail5:"So pray to none but Allah, invoke none but Allah, ask for help from none but Allah, swear by none but Allah, offer animals as a sacrifice to none but Allah .... etc, and that means all that Allah and His Messenger Muhammad(PBUH) order you to do, in the Quran and in the Sunnah(legal ways of prophet Muhammad(PBUH) you must do, and all that Allah and His Messenger Muhammad (PBUH) forbid you, you must not do. ",
          detail6:'This is (your confession for the ) "Oneness of the worship of Allah."',
          ancorName:"Tawhid al-Uloohiyyah (to single-out Almighty God alone for worship)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Tawhid al-Asmaa was-Sifaat (the uniqueness of God\'s Names and Attributes)',
          detail:"Tawhid al-Asmaa was-Sifaat is the uniqueness of Almighty God-the Most High - with regards to His Names and His Attributes, by affirming that which God has affirmed for Himself - whether in His Book(i.e the Qur'an) or by the tongue of His Messenger - may the peace and blessings of God be upon him - without distorting the Names and Attributes(Tahreef), denial of the Names and Attributes(Ta'teel), saying how they are(Takyeef), or making any resemblance with the creation (Tamztheel). ",
          detail1:'" for example, Allah may not be given the name al-Ghaadib (the Angry One), in spite of the fact that He has said that He gets angry because neither Allah nor His messenger has used this name.',
          detail2:'This may seem to be a very fine point, but it must be maintained in order to prevent the false description of God. That is, finite man is in no position to define the infinite Lord of creation. ',
          detail3:'God says in the Quran "There is nothing like Him and He is hearer and seer of all" Q(42:11)',
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Tawhid al-Asmaa was-Sifaat (the uniqueness of God's Names and Attributes)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Islamic Monotheism - Tawhid(The oneness of Allah)[part2]',
          detail:"In spite of the wide implications of the first and last categories of Tawhid, firm belief in them alone is not sufficient to fulfill the Islamic requirements of Tawhid.",
          detail1:' Tawhid ar-Ruboobeyah and Tawhid al Asmaa Was Sifaat must be confessions with your heart: "O Allah! I testify that Muhammad (PBUH) is Your Messenger." That means that none has the right to be followed after Allah, but Prophet Muhammad(as he is the last of His messengers. As Allah says:',
          detail2:'"Mohamad is not the father of any man among you, but he is the Messenger of Allah and the last(end) of the Prophets. And Allah is Ever All-Aware of everything"(Q33:40)',
          detail3:'"And whatsoever the  Messenger(Muhammad) gives you take it and whatsoever he forbids you to abstain from it"(Q59:7).',
          detail4:'"Say(O Mohammad to Mankind): "if you (really) love Allah, then follow me(ie accept Islamic monotheism, follow the Qur\'an and the Sunna) "(Q3:31)',
          detail5:'As for others than Muhammad (their statements are to be taken or rejected based on their accordance with Allah\'s Book (i.e. the Quran) and with the Sunnah(legal ways, orders, acts of worship, statements) of the Prophet. As the Divine Revelation stopped after the death of Prophet Muhammad (PBUH) and will not resume except at the time of the descent of Isa(Jesus (PBUH) - son of Maryam(Mary); and he(i.e. Jesus (PBUH) will rule with justice according to the Islamic laws, during the last days of the world, as it has been mentioned in the authentic hadith (ie narrations of Prophet Muhammad (PBUH)(sahih-Al-Bukhari)',
          detail6:'**It is essential to utter ```La Ilaha Illa Allah, Muhammadun-Rasulu Allah```(none has the right to be worshipped but Allah, and Muhammad is the Messenger of Allah). As it has come in the statement of Prophet Muhammad(PBUH) to his uncle Abu Talib at the time of the latter\'s death: "O uncle, if you utter it (```La Ilaha Illa Allah, Muhammadun-Rasulu Allah```(none has the right to be worshipped but Allah and Muhammad is the Messenger of Allah).) Then I shall be able to argue on your behalf before Allah on the Day of  Resurrection. " Similarly, when Abu Dharr Al-Ghifari embraced Islam, he went to the Masjid al-Haram and he proclaimed it loudly in front of the Quraish infidels until he was beaten severely.',
          detail7:"*It is essential that the limbs and all the other parts and organs of one's body testify to it, and this is very important as regards its meaning.",
          detail8:"So whoever has confessed shahadah(to his Lord) shall not commit sins like robbing, killing, stealing, illegal sexual intercourse, eating pork, drinking alcoholic beverages, taking advantage of orphan's property, cheating in trade, bribery, and earning money through illegal means, telling lies, backbiting, etc otherwise the limbs and all the other parts and organs of his body will testify against him that he was a liar in his words which he pledged to Allah.",
          detail9:"In case he commits the above sins, he should know that it is a sin that obliges him to repent to Allah and ask His forgiveness as (his)body parts (i.e skin, private parts, hands, tongue, ears,etc) will testify to the above-mentioned crimes(i.e actions) against himself on the Day of Resurrection",
          detail10:"And with the confession of this great statement(i.e principle) a person enters the fold of the Islamic religion accordingly. It is essential for him to believe in all the messengers of Allah and not to differentiate between them",
          ancorName:"Islamic Monotheism - Tawhid(The oneness of Allah)[part2]",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Polytheism',
          detail:"Polytheismthe opposit of Tawhid ",
          detail1:'Polytheism the opposite of Tawhid is expressed by the Arabic term ``Shirk``. derived from the root ``Sh-r-k`` which conveys the notion of  "sharing" or "partnerships". ',
          detail2:'The Word Sharik(plural ``shurakaa``) means "partner" or "associate."It encompasses far more than mare blatant forms of idolatry and denial of Allah\'s Unity. The term ```shirk``` means associating partners with Allah and the related term ```mushrik`` Is applied to someone guilty of such polytheistic association.Allah says that on the day of judgment He can forgive another sin but not shirk.(Q4:48)',
          detail3:"Thus Shirk is the greatest thing Allah has prohibited.",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Polytheism",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Pillars of islam',
          detail:"Islam is a religion of God based on five pillars:",
          detail1:"",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Pillars of islam",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:' Testimony (ie declaration of faith)',
          detail:"1.) Testimony (ie declaration of faith). The first principle of Islam is to make a solemn declaration of FAITH by reciting and testifying That:",
          detail1:'"La ilaha ill-Allah, Muhammad-ur-Rasool-ullah"',
          detail2:'The meaning is that "There is no deity but Allah and Muhammad is the Apostle of Allah',
          detail3:"This is what is said when one reverts to Islam. A mere declaration without practicing the rest of the pillars does not make a person a true Muslim. This pillar rests on the oneness of Allah. This has been explained above under Tawhid which is an Islamic monotheism.",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:" Testimony (ie declaration of faith)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Prayer (salaat) - FIVE Daily obligatory prayers',
          detail:"prayer (salaat). Prayer is direct communication between the slave and his God. Before commencing with prayer, man must be purified through ablution(Holy Qur'an 5:6). A true Muslim must pray five times a day. Thus there are FIVE daily obligatory prayers.The times of each of the prayers are related to the rising and setting of the sun. These will vary in different parts of the world. These five daily prayers with their times and rakaats are:",
          detail1:"Subh(salatul-Fajr)",
          detail2:'This is the early morning prayer that must be offered after dawn and before sunrise. It has two Rakaat Fard. (two compulsory units) and 2 units recommended.',
          detail3:"Salatul-Zuhr: ",
          detail4:"This is the early afternoon prayer, the times for which commences immediately after the sun has crossed the meridian and has begun to decline. the period lasts till the sun is about midway on its course to set. It has four Rakaat Fard and two or four rakaats recommended",
          detail5:"salatul-Ars:",
          detail6:" This is the late afternoon prayer that must be offered sometimes after the sun is about midway on its course to set until a little before it actually begins to set. it has four Rakaat Fard and two or for raaats recommended.",
          detail7:'Salatu-Maghrib:',
          detail8:' This is the evening prayer, which must be offered between the sunset and the disappearance of the light similar(civil twilight period), to the light at down. which follows when the red glow from the horizon in the west has vanished. It has three Rakat Fard and two rakaats recommended',
          detail9:'Salatul - isha:',
          detail10:' This is the night prayer that must be offered anytime after the time of salatul Maghrib comes to an end and before the break of dawn, but it should preferably be offered before midnight. it has four rakaat Fard and two or four raaats recommended',

          ancorName:"Prayer (salaat) - FIVE Daily obligatory prayers",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Rakaat:',
          detail:"A prayer consist of two, three or four Rakaats. In his daily prayer, a Muslim follows a sequence of postures accompanied by a set of words (in Arabic), which include praise, requests, and thanks. the postures include standing erect(Qiyam) and placing the right hand upon the left on the chest and reciting some verses from the holly Quran bending forward (Ruku); kneeling and sitting Together (Sajdah and Qa'dah). together the words and postures form one rakaat.",
          detail1:"prayer is the act of worshipping Allah according to the teaching of the Holy Prophet of Islam. The essential request for offering prayers are:",
          detail2:'1.) The worshipper must be a Muslim',
          detail3:"2.) the worshiper's clothes anybody must be free from all impurities",
          detail4:"3.) the place where the prayer is to be offered should be pure and clean",
          detail5:"4.) The part of the body between the navel and the knees of a male worshipper must be fully covered and the whole body except the hands and face of a female worshipper",
          detail6:"5.) The worshipper must face  Ka'ba in the great mosque at Makkah(Saudi Arabia) and the direction of Ka'ba outside Makka",
          detail7:"6.)the worshipper must form the Niyyat(intention) in his or her mind of the particular prayer, Fard(obligatory) or sunnah or Nafl(optional), he or she is about to offer",
          detail8:"7.) The worshipper must observe the times and rules prescribed for the respective prayers and  instantly heed the Azan (call) for the prayers",
          detail9:"8.) the worshipper must have performed the Wudu (Ablution)",
          detail10:"It is also an obligation upon Muslims to keep the body clean from dirt and all minor impurities and to be ever ready for prayers. To this end, Muslims must wash the private part of their body with water whenever any impure matter issues from the body.",
          detail11:"the salah must be performed in the Arabic language to the best of each worshiper's ability(although any du'a or extra prayer said afterward need not be in Arabic), the lines are to be recited by heart, although beginners may use written aids. the worshipper's body and clothing, as well as the place of prayer, must be cleansed",
          detail12:"All prayers should be conducted within the prescribed time period or Waqt(Arabic for 'time') and with appropraite number of units('raka'ah) While the prayers may be made at any point within the waqt. it is considered best to begin them as soon as possible after the call to prayer is heard.",
          ancorName:"Rakaat:",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Importance of Prayer(Salaat)',
          detail:"1.) A lesson in discipline and willpower;(Q2:153,Q2:43,Q2:45)",
          detail1:"2.) A practice of devotion to God and all worth objectives;",
          detail2:'3.) A vigilant reminder of God and constant remembrance of his Goodness;',
          detail3:"4.) A seed of spiritual cultivation and moral soundness",
          detail4:"5.) A Guide to the most upright way of life",
          detail5:"6.) A safeguard against indecency and evil against wrong deviation and stray",
          detail6:"7.)A demonstration of true equality, solid unity, and brotherhood",
          detail7:"8.) An expression of thankfulness to God and appreciation of Him,",
          detail8:"9.)A course of inner peace and stability;",
          detail9:"10) An abundant source of patience and courage of hope and confidence.",
          ancorName:"Importance of Prayer(Salaat)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },

        {
          name:'Alms -Giving(Zakaat)',
          detail:"Zakat (compulsary alms-giving) is a fixed protion of 2.5% of ones yearly balance which is obligatory to give away annually for the benefit of the poor and needy. ",
          detail1:"only those who have a certain fixed minimum amount of wealth are expected to remove it. the obligation of zakat is found in (Q 9:60).(Q2:261 - 268). ",
          detail2:'It may be added here that a great warning has been given to those who do not pay Zakaat.',
          detail3:'"And (There are) those who hoard gold and silver and do not spend it in the cause of Allah so give them the tidings of a painful punishment" (Q9:34)',
          detail4:"Ther are two types of Zakat",
          detail5:"1.)Zakat on Property (Zakat al-mal )",
          detail6:"2.)Zakat on yourself(Zakat al-Fitr)",
          ancorName:"Alms -Giving(Zakaat)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Zakat on Property(Zakat al-mal)',
          detail:"It is compulsory to give Zakat on the following type of property",
          detail1:"LiveStock(Goats, camels, and cows,), Cereals(rice, corn, and wheat), Fruits(Dates and grapes only), Gold and silver (includes foreign-exchange, valuable notes and savings), Minerals and buried treasure, Stocks(Goods to be traded)",
          detail2:'The Zakat is contribution of 2.5% annually of the value of the accumulated wealth, investments and/or savings, when both the nisab(minimum value ) and haul (a period of one Islamic year or 354 days) are due.',
          detail3:"It is very important to calculate your Zakat correctly, and to ensure you are paying enough Zakat each year. As Zakat is a percentage of your wealth, the amount of Zakat you need to pay each year will vary depending on your income, savings and expenditure. ",
          detail4:"This is often affected by outside forces like inflation, recessions and political movements. One of the most important things to do is to calculate zakat on salary if you are working, and this can sometimes be a bit confusing.",
          detail5:"",
          detail6:"",
          ancorName:"Zakat on Property(Zakat al-mal)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Zakat Fitr (Zakat on yourself)',
          detail:"Zakat Fitr is given at the end of the fast of ramadan before the Eid prayers.",
          detail1:"The minimum amount is one sa` (four double handfuls) of food, grain or dried fruit for each member of the family. This calculation is based on Ibn 'Umar's report that the Prophet made Zakat al-Fitr compulsory and payable by a sa` of dried dates or a sa` of barley.",
          detail2:'The Hanafi school permits paying Zakat al-Fitr in the form of cash, equivalent to the above amount, while this is not permitted Maliki, Shafi\'i and Hanbali schools.',
          detail3:"Using cash as a form of payment became the adopted position by many official fataw councils around the world.",
          detail4:'A companion of Mohammed, Abu Sa`eed al-Khudree said, "In the Prophet\'s time, we used to give it (Zakatal-Fitr) as a sa` of food, dried dates, barley, raisins or dried cheese".',
          detail5:"(According to the majority of Sunni scholars One Sa'a is approximately between 2.6 kg to 3 kg.)",
          detail6:"The distribution of Zakat al-Fitr is the same as that of Zakat, and is included within its broader sense. Those who may receive Zakat al-Fitr are the eight categories of recipients mentioned in Surat Al-Tawbah, [9: 60].",
          detail7:"They include :",
          detail8:"he poor,the needy,collectors of Zakah,reconciliation of hearts(Those who have converted to Islam and are in need),freeing captives / slaves (fee al-Riqab),debtors,those fighting for a religious cause or a cause of God (Fī Sabīlillāh) or for Jihad in the way of Allah,the traveler.",
          detail9:"Zakat al-Fitr must go to the above-mentioned categories. The Zakat al-mal cannot be used for any other such things either.",
          detail10:"Note: That it is zakat on property that is a pillar of Islam and not Zakaatul fitr",
          ancorName:"Zakat Fitr (Zakat on yourself)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'HOW TO CALCULATE ZAKAT',
          detail:"First of all you’ll need to work out whether you’re obligated to pay Zakat by looking at whether what you own meets the Nisab. This is the minimum threshold of wealth that one must own before they are obligated to pay Zakat.",
          detail1:"The value of the Nisab in prophetic tradition is 87.48 grams of pure gold or 612.36 grams of pure silver so the monetary value of the Nisab will vary according to current prices. The monetary value of the Nisab varies year to year, so it is important to ensure you have the right figure.",
          detail2:'Due to the significant difference in the cost of gold and silver, the Nisab for silver is much lower than that of gold. Although either of the two values can be used, many scholars advise that we apply the Nisab of silver when calculating our Zakat so that more people are eligible to pay, thus resulting in more needy people being supported.',
          detail3:"Zakat should be calculated and paid on any surplus wealth that you have owned for at least one lunar year.",
          detail4:"This Includes:",
          detail5:"Gold, silver, precious metal, including ornaments/jewellery containing gold/silver",
          detail6:"Stocks and shares",
          detail7:"Money you have lent to others",
          detail8:"Cash in bank accounts, committees or at home",
          detail9:"Any business stock",
          detail10:"Pensions and Property you own for investment purposes",
          ancorName:"HOW TO CALCULATE ZAKAT",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'CALCULATE ZAKAT ON SALARY',
          detail:"To be eligible for zakat, you have to own wealth above the nisab value for one full year, and this means that if you receive a salary but all of it is spent on your daily living, you have no wealth left on which to pay Zakat.",
          detail1:"This means you do not need to be Zakat. One full year starts from the date of possession of the nisab which is said to be the minimum wealth on which zakat has to be paid.",
          detail2:'It is especially important to be mindful when calculating your Zakat, if your salary is inconsistent, and you do not receive the same amount each month. It is important to be aware how much you are spending and are able to save over the year, as this will determine exactly how much Zakat you must pay.',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"CALCULATE ZAKAT ON SALARY",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Importance of Alms-Giving(Zakat)',
          detail:"zakat purifies the property of the people and clears it from  shares which do not belong to it anymore.",
          detail1:"zakat purifies the heart of the contributor form selfishness and geed of wealth",
          detail2:'zakat reduces to the minimum of the sufferings of the needy and the poor members of the society bridging the gap between the poor and the rich.',
          detail3:" ",
          detail4:"zakat is a healthy form of internal security against selfish and penetration of  the spiritual and the responsive interactions between the individual and the society",
          detail5:"",
          detail6:"",
          ancorName:"Importance of Alms-Giving(Zakat)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Fasting in the month of Ramadan',
          detail:"The ninth month of the Islamic calendar is Ramadan. Ramadan is the month of Fasting.",
          detail1:" it was during the month That the Holy Qur'an was revealed through Prophet Muhammad (PBUH) to the entire mankind.",
          detail2:' Fasting during this month is compulsory except for ill-health and other adverse conditions. ',
          detail3:"Fasting begins at dawn and ends at sunset.",
          detail4:"Fasting is another unique moral and spiritual characteristic of Islam. Fasting means to abstain \"completely \" from food, drinks, and intimate intercourse, before the break of dawn till sunset. Fasting as a pillar of Islam is during the entire month of Ramadan, the ninth month of the Islamic year",
          detail5:"Fasting Ramadan is obligatory on every responsible and fit Muslim because Allah says in (Q2:183-187) O Ye who believe, fasting is prescribe on you as was prescribe for those before you that you may become almutaqun...",
          detail6:"But there are other times when it is recommended to make voluntary fasting, after the traditions of Prophet Muhammad. Among these times are Mondays and Thursdays of every week. a few days of each month in the two months heralding coming Ramadan. ie, Rajab and Sha'ban, six days after Ramadan following the 'Eid ul-Fitr Day. Besides, it is always compensating to fast any day of any month of the year, except the 'Eid Days and Fridays when no Muslim should fast.",
          detail7:"However, we may repeat that the only obligatory fasting is that of Ramadan which may be 29 or 30 days. depending on the moon's positions. this is a pillar of Islam and any failure to observe it without reasonable excuses is a grave sin in the sight of God.",
          ancorName:"Fasting in the month of Ramadan",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Who Must Fast?',
          detail:"Fasting Ramadan is compulsory uponevery Muslim,male or female who has these qualities:",
          detail1:"To be mentally and physically fit,which means to be sane and able.",
          detail2:'To be full age, the age of puberty and discretion, which is normally about fourteen. children under this ages should be encouraged to start this good practice on easy levels , so when they reach the age of puberty they will be mentally and physically prepared to observe fasting.',
          detail3:"To be present at one's permanent settlement. your home town, ones farm and one's business premises, etc This means not to be on a journey of about fifty miles or more.",
          detail4:"To be fairly certain that fasting is unlikely to cause you any harm, physical and mental, other than the normal reactions of hunger and thirst etc",
          detail5:"",
          detail6:"",
          ancorName:"Who Must Fast?",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Those Excepted from fasting and what they should do:',
          detail:"These said qualifications exclude the following categories:",
          detail1:"Children under the age of puberty and discretion.",
          detail2:'insane people who are unaccountable for other deeds. People of these two categories are exempted from the duty of fast and no compensation or any other substitute is enjoined on them',
          detail3:"Men and Women who are too old and feeble to undertake the obligation of fast and bear its hardships. such people are exempted from this duty but they must offer at least one needy poor Muslim an average full meal or its value per person per day.",
          detail4:"Sick people whose health is likely to be severely affected by the observance of fast. they may postpone the fast as long as they are sick to the latter date and make up for it a day for a day.",
          detail5:"Travellers may break the fast temporarily during their travel only and make up for it in later days a day for a day",
          detail6:"pragnat women and women breast-feeding their children may also break the fast if its observance is likely to endager their own health or that of their infants. but they must make up for the fast at a delayed time , a day for a day",
          detail7:"women in the -period of menstrualtion(of a maximum often days or of confinement(of a maximum of forty day)); they must postpone the fast till recovery and then make up for it day for a day. ",
          detail9:"It should be under stood that here like in all the other Islamic undertakings, the intention must be made clear that this action is undertaken in obedience of God, in response to his command and out of love of Him",
          ancorName:"Those Excepted from fasting and what they should do:",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'What spoils fasting?',
          detail:"The fast of any day of Ramadan becomes void by intentionally eating or drinking and smoking or indulgence in any intimate intercourse and by allowing anything to enter through the mouth into the interior part of the body. And if this is done deliberately without any lawful reason, This is a major sin which only renewed repentance can expiate.",
          detail1:"if anyone, through forgetfulness, does something that will ordinarily break the fast, observeaces is not nullified, and his fast stands valid provided he stops doing that thing the moment he realizes what he is doing.",
          detail2:"on completion of the fast of Ramadan, the special charity known as zakatul-tu-fitr (charity of 'fast-breaking') must be distributed before 'Eid-ul-Fir",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"What spoils fasting?",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'General Recommendations',
          detail:"it is strongly recommended by Prophet Mohamad to observe the practices, especially during Ramadan:",
          detail1:'To have the light meal before the break of dawn, known as Suhoor,To eat a few dates or start breaking the fast by plain water right after sunset, saying this prayer  "Allahhumma laka sumna, wa\'ala rizqika aftarna"  (O Allah! for your sake have we fasted and now we break the fast with the food you have given us)',
          detail2:'To make your meals as light as possible because, as the prophet put it the worst thing a man can fill is his stomach.',
          detail3:"To observe the supererogatory prayer known as Taraweeh",
          detail4:"To exchange social visits and intensify humanitarian services.",
          detail5:"To increase the study and the recitation of the Quran",
          detail6:"To Exert the utmost patients and humbleness.",
          detail7:"To be extraordinarily cautious in using one's senses, one's mind and especially the tongue to abstain from careless gossip and avoid all suspicious motions. Q2:183-187",
          ancorName:"General Recommendations",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Importance of Fasting(Sawm)',
          detail:"-it teaches man the principle of sincere love.",
          detail1:"-it equips man with a creative sense of hope and an optimistic outlook on life.",
          detail2:'-it imbues man with a genuine virtue of effective Devotion,honest, Dedication closeness to God.',
          detail3:"-it cultivars in man a vigilant and sound conscience.",
          detail4:"-it indoctrinates man in patience and Unselfishness.",
          detail5:"-it is an effective lesson in applied moderation and willpower.",
          detail6:"-it provides man with a Transparent sole to transcend a clear mind to think and a light body to move and act.",
          detail7:"-it shows man a new way of wise saving and sound budgeting.",
          detail8:"it enables man to master the art of mature Adaptability",
          detail9:"it grounds man in disciplines and healthy survival",
          ancorName:"Importance of Fasting(Sawm)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Prigrimage(Hajj)',
          detail:"Hajj or polgrimage to Makka is one of the five pillars of Islam.",
          detail1:"Hajj was made obligatory in the 9th year of Hijra. The Holy prophet sent off 300 Muslims under the leadership of Hazrat Abubakr Siddique(May Allah be pleased with him) to Makkah so that they could perform Hajj. ",
          detail2:'It was also made unlawful to perform Tawaaf(circling of Ka\'ba) with naked body.',
          detail3:"The performance of Hajj(Pilgrimage) is incumbent on all Muslims, at least once in a lifetime.if the circumstances permit. Hajj is obligatory only when an individual is in a position , both physically and materially, to undertake the journey to mecca, and to make sufficient provision for their dependents during the period of their absence.",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Prigrimage(Hajj)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Types of Hajj',
          detail:"1.)Tamattu' Hajj",
          detail1:"Tamattu means performing 'Umrah during the Hajj season, and on the Day of Tarwiah, a pilgrim gets into the state of Ihram for Hajj. Anyone intending to perform a Tamattu Hajj should on approaching the Miqat make intention for 'Umrah. After fulfilling the Hajj rituals, one should offer a sacrificial animal.",
          detail2:'2.)Qiran Hajj',
          detail3:"In this type of Hajj, a prigrim should declare his intention to perform both Hajj and Umrah together. only when he throws the jumarah of Al-Aqaba, gets his hair shaved or cut that he can put off his Ihram. However, he should offer a sacrificial animal",
          detail4:"3.)Ifrad Hajj",
          detail5:"in the Miqat, a pilgrim of Ifrad Hajj declares his intention fo Hajj only. He maintains his Ihram p to the Day of Sacrifice. No offering is required from him.",
          detail6:"",
          ancorName:"Types of Hajj",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Umrah',
          detail:"1.)Rituals of 'Umrah",
          detail1:"In Arabic the word 'Umrah is derived from I'timar which means a visit. However 'Umrah technically means paying a visit to Ka'bah, performing Tawaf[circumambulation] around it , walding between Safa and Marwah seven times. A performer of Umrah puts off his Ihram by haveing his hair shaved or cut",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Umrah",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        }
        ,
        {
          name:'pillars of Hajj',
          detail:"There are Three basic pillars for performing Hajj.",
          detail1:"1.To enter into the State of 'Ihram' and have the intention to perform the Pilgirmage",
          detail2:'2. to stay at the field of "Arafat" on the ninth of Zul-Hajj. If someone cannot go to the field of Arafat even for a short time then his/her pilgrimage will not be complete. He/she has to perform the pilgrimage again the following year.',
          detail3:"3. Additional circlingto the \"ka bah\" that is done after the stay a the field of \"Arafat\" and performed form the tenth to the end of the month.",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"pillars of Hajj",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        }
        ,
        {
          name:'Upon Whom is it obligatory to perform Hajj',
          detail:"An adult Muslim of sane mind and able body and having means to bear the expenses must perform this act of worship once in his /her lifetime. There should be peace on the way to Macca and there should be no hindrance or restriction in travelling to Mecca.",
          detail1:"Hajj is not obligatory for children, the sick, and those who are unable to bear the expenses for hajj.",
          detail2:'Q2:189',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Upon Whom is it obligatory to perform Hajj",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        }
        ,
        {
          name:'What are the timings of Hajj(pilgrimage)',
          detail:"There are specific months for performing the hajj and are called \"Months of Pilgrimage\".",
          detail1:"There Three Islamic months are Hawal, Zul Qa'da and Zul-Hajj.",
          detail2:'During these three \"Months of Hajj,\" one prepares for the pilgrimage, attains good morals and completes other physical conditions for the pilgrimage. ',
          detail3:"All the essential duties of the pilgrimage have to be completed between the 8th and the 13th day of Zul-Hajj. ",
          detail4:"Additional tawaaf (circling around the Ka'ba), however, may be performed until the end of the month of Dul -Hajj.Importance of Pilgrimage (Hajj)",
          detail5:"",
          detail6:"",
          ancorName:"What are the timings of Hajj(pilgrimage)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'Importance of Pilgrimage (Hajj)',
          detail:"- It is a wholesome demonstration of the Universality of Islam and the brotherhood and equality of the Muslims.",
          detail1:"- it is to confirm the commitment of a Muslim to God and their readiness to forsake the Material interest in His(Allah) service",
          detail2:'- It is to acquaint the pilgrims with the spiritual and historical environment of Prophet  Mohamad (P.B.U.H) so that they may derive warm inspiration and strengthened their faith.',
          detail3:"-It is also to commemorate the Divine rituals observed by Abraham and Ismael, who are known to have been the first pilgrims to the house of God on earth ie the Ka'bah at Makka(Makkah)",
          detail4:"- it is a reminder of the Grand Assembly on the Day of judgment when people will stand equal before God waiting for their final Destiny and where no superiority of race or stock can be claimed.",
          detail5:"",
          detail6:"",
          ancorName:"Importance of Pilgrimage (Hajj)",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'',
          detail:"",
          detail1:"",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'',
          detail:"",
          detail1:"",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'',
          detail:"",
          detail1:"",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
        {
          name:'',
          detail:"",
          detail1:"",
          detail2:'',
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
      ],
      additionalRead:[
        {
          title:"Additional reads",
          url:"ls"
        },
      ],
      source:[
        {
          name:"Islam Sources",
          link:"www.google.com"
        },
      ],
      KnowledgeCheck:[
        {
          check:"what is Islam"
        },
        {
          check:"In your own words, discribe the concept of God in Islam"
        },
        {
          check:"what is Tawhid"
        },
        {
          check:"what is Tawhid ar-Ruboobiyyah"
        },
        {
          check:"what is Tawhid al-Uloohiyyah"
        },
        {
          check:"what is Tawhid al-Asmaa was-Sifaat"
        },



      ],
    },
    companyLevel1:[
      {
        name:"The Holy Quran",
        logo:'https://en.shafaqna.com/wp-content/uploads/2017/11/main-qimg-34e6fd0e49307677e37b0aabead7124f-c.jpg',
        menu2:[
          {
            name:'Surah Alfatiha',
            ancorName:"Surah Alfatiha",
            verseInfo:{

              verses:[
                {
                  verseName:"surah Fatiha verse1",
                  verseDetail:[
                    {
                      arabic:[{word:"arabic1",source:"source1"},{word:"arabic2",source:"source2"},{word:"arabic3",source:"source3"}],
                      english:[{word:"english1",source:"source1"},{word:"english2",source:"source2"},{word:"english3",source:"source3"}],
                      arabicAudio:[{arabAudio:"arabic1",engAudio:"english1",source:"source1"},{arabAudio:"arabic2",engAudio:"english2",source:"source2"},{arabAudio:"arabic3",engAudio:"english3",source:"source3"}],

                    }
                  ],
                  allTasfseer:[
                    { tafseerArab:"tafaseer1 of verse 1",tafseerEnglis:"tafaseer1 of verse 1", source:"sorce of taseer1"},
                    { tafseerArab:"tafaseer2 of verse 1",tafseerEnglis:"tafaseer2 of verse 1", source:"sorce of taseer2"},
                    { tafseerArab:"tafaseer3 of verse 1",tafseerEnglis:"tafaseer3 of verse 1", source:"sorce of taseer3"}
                  ],

                  ancorVerseName:"surah Fatiha verse1"
                },
                {
                  verseName:"surah Fatiha verse2",
                  ancorVerseName:"surah Fatiha verse2"
                },
                {
                  verseName:"surah Fatiha verse3",
                  ancorVerseName:"surah Fatiha verse3"
                }
                ,
                {
                  verseName:"surah Fatiha verse4",
                  ancorVerseName:"surah Fatiha verse4"
                }
                ,
                {
                  verseName:"surah Fattiha verse5",
                  ancorVerseName:"surah Fatiha verse5"
                },
                {
                  verseName:"surah Fatiha verse6",
                  ancorVerseName:"surah Fatiha verse6"
                },
                {
                  verseName:"surah Fatiha verse7",
                  ancorVerseName:"surah Fatiha verse7"
                },
                {
                  verseName:"surah Fatiha verse8",
                  ancorVerseName:"surah Fatiha verse8"
                },



                {
                  verseName:"surah Fatiha verse11",
                  ancorVerseName:"surah Fatiha verse11"
                },
                {
                  verseName:"surah Fatiha verse12",
                  ancorVerseName:"surah Fatiha verse12"
                },
                {
                  verseName:"surah Fatiha verse13",
                  ancorVerseName:"surah Fatiha verse13"
                }
                ,
                {
                  verseName:"surah Fatiha verse14",
                  ancorVerseName:"surah Fatiha verse14"
                }
                ,
                {
                  verseName:"surah Fatiha verse15",
                  ancorVerseName:"surah Fatiha verse15"
                },
                {
                  verseName:"surah Fatiha verse16",
                  ancorVerseName:"surah Fatiha verse16"
                },
                {
                  verseName:"surah Fatiha verse17",
                  ancorVerseName:"surah Fatiha verse17"
                },
                {
                  verseName:"surah Fatiha verse18",
                  ancorVerseName:"surah Fatiha verse18"
                }
              ]
            }
            // popup1Name:"",
            // popup1:"",
            // popup2Name:"",
            // popup2:"",


          },
        ],
        additionalRead:[
          // {
          //   title:"Additional reads",
          //   url:"ls"
          // },
        ],
        source:[
          {
            name:"Islam Sources",
            link:"www.google.com"
          },
        ],
        KnowledgeCheck:[
          // {
          //   check:"what is Islam"
          // },
        ],

        people:[ ]
      },

      {
        name:"Hadith",

        people:[],
      },
      {
        name:"Seerah Of Prophet Mohamad",

        people:[],
      }


    ],


  },
  {
    learningTitle:"Christainity",
    companyName:"Christainity",
    companyHeadOfficeLocation:"Cameroon | Buea | Ndongo",
    initialData:{
      name:"About Christainity",
      logo:'https://media.istockphoto.com/vectors/church-christian-with-line-art-style-design-inspiration-vector-id1171075393?k=20&m=1171075393&s=612x612&w=0&h=c7oz4taiX663bNVnAWscj-2RP0OY0EcEhQ1mPDK9wjg=',
      menu:[
        {
          name:'Introduction',
          detail:"Christainity",
          detail1:"",
          detail2:"",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Introduction",
          // popup1Name:"",
          // popup1:"",
          // popup2Name:"",
          // popup2:"",


        },
      ],
      additionalRead:[
        {
          title:"Additional reads",
          url:"ls"
        },
      ],
      source:[
        {
          name:"Christainity Sources",
          link:"www.google.com"
        },
      ],
      KnowledgeCheck:[
        {
          check:"How many number of book are in the old testament"
        }


      ],
    },
    companyLevel1:[
      {
        name:"The Old Testament",
        menu2:[

          {
            name:'Introduction',
            ancorName:'Introduction',
            detail:"detail 1",
            verses:[
              {
                hebrew:["בְּרֵאשִׁ֖ית","בָּרָ֣א","אֱלֹהִ֑ים","אֵ֥ת","הַשָּׁמַ֖יִם","וְאֵ֥ת","הָאָֽרֶץ",":"],
                transliteration:["b·rashith","bra", "aleim", "ath","e.shmim","u.ath","e.artz", ":"],
                english:["in.beginning","he.created", "Elohim",">>","the.heavens", "and.>>","the.earth",":"],
                en_trans:"In the beginning God created the heaven and the earth."
              }
            ]
          },
        ],
        people:[ ]
      },

      {
        name:"The New Testament",

        people:[],
      }

    ],


  }
]
